import {
    FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILURE,
    FETCH_USERS, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE,
    FETCH_ASSIGNMENTS_FOR_USER, FETCH_ASSIGNMENTS_FOR_USER_SUCCESS, FETCH_ASSIGNMENTS_FOR_USER_FAILURE,
    REMOVE_USER, REMOVE_USER_SUCCESS, REMOVE_USER_FAILURE,
    SAVE_USER, SAVE_USER_SUCCESS, SAVE_USER_FAILURE,
    UPDATE_CSV_TO_UPLOAD, UPDATE_USERS, UPDATE_SEARCH_TERM, UPDATE_THUMBNAIL_TO_UPLOAD, SET_USER, CLEAR_USER, EMPTY_USERS, INCREMENT_PAGE_NUMBER,
    UPLOAD_IMPORT_USERS, UPLOAD_IMPORT_USERS_SUCCESS, UPLOAD_IMPORT_USERS_FAILURE
} from './constants';

import { USER_ROLES } from 'utils/constants';

const emptyUser = {
    firstName: '',
    lastName: '',
    userName: '',
    department: {},
    role: USER_ROLES.INBOX_ONLY
};

const initialState = {
    allUsers: [],
    user: {
        firstName: '',
        lastName: '',
        userName: '',
        department: {}
    },
    csvToUpload: null,
    thumbnailToUpload: null,
    pageNumber: 0,
    pageSize: 25,
    hasMore: true,
    groups: [],
    searchTerm: '',
    sortBy: 'modified',
    sortDirection: true,
    filterBy: '',
    isFetching: false,
    isFetchingAssignments: false,
    isSaving: false,
    isUploading: false,
    error: {},
    saveError: {},
    uploadError: {}
};

function usersReducer(state = initialState, action) {
    switch(action.type) {
        case FETCH_USER:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_USER_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                user: action.data
            });
        case FETCH_USER_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_USERS:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_USERS_SUCCESS:
            let hasMore = true;
            if(action.data.length === 0) {
                hasMore = false;
            }
            return Object.assign({}, state, {
                allUsers: state.allUsers.concat(action.data),
                pageNumber: state.pageNumber + 1,
                hasMore: hasMore,
                isFetching: false
            });
        case FETCH_USERS_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error
            });
        case FETCH_ASSIGNMENTS_FOR_USER:
            return Object.assign({}, state, {
                isFetchingAssignments: true,
                error: {}
            });
        case FETCH_ASSIGNMENTS_FOR_USER_SUCCESS:
            return Object.assign({}, state, {
                isFetchingAssignments: false
            });
        case FETCH_ASSIGNMENTS_FOR_USER_FAILURE:
            return Object.assign({}, state, {
                isFetchingAssignments: false,
                error: action.error
            });
        case INCREMENT_PAGE_NUMBER:
            return Object.assign({}, state, {
                pageNumber: state.pageNumber + 1
            });
        case SET_USER:
            return Object.assign({}, state, {
                user: action.data
            });
        case CLEAR_USER:
            return Object.assign({}, state, {
                user: JSON.parse(JSON.stringify(emptyUser)),
                saveError: {}
            });
        case EMPTY_USERS:
            return initialState;
        case UPDATE_USERS:
            return action.data;
        case UPDATE_SEARCH_TERM:
            return Object.assign({}, state, {
                searchTerm: action.data
            });
        case UPDATE_CSV_TO_UPLOAD:
            return Object.assign({}, state, {
                csvToUpload: action.data
            });
        case UPDATE_THUMBNAIL_TO_UPLOAD:
            return Object.assign({}, state, {
                thumbnailToUpload: action.data
            });
        case SAVE_USER:
            return Object.assign({}, state, {
                isSaving: true,
                saveError: {}
            });
        case SAVE_USER_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                user: action.data
            });
        case SAVE_USER_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                saveError: action.error
            });
        case REMOVE_USER:
            return Object.assign({}, state, {
                isSaving: true
            });
        case REMOVE_USER_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                user: JSON.parse(JSON.stringify(emptyUser))
            });
        case REMOVE_USER_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case UPLOAD_IMPORT_USERS:
            return Object.assign({}, state, {
                csvToUpload: action.data,
                isUploading: true,
                uploadError: {}
            });
        case UPLOAD_IMPORT_USERS_SUCCESS:
            return Object.assign({}, state, {
                csvToUpload: null,
                isUploading: false
            });
        case UPLOAD_IMPORT_USERS_FAILURE:
            return Object.assign({}, state, {
                isUploading: false,
                uploadError: action.error
            });
        default:
            return state;
    }
}

export default usersReducer;



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/users/reducers.js